import { ActionTree, ActionContext } from 'vuex';

import { careClient } from '@/http-client';
import { snakeToCamel, camelToSnake } from '@/utils';

import { FindI, RootStateI } from '../state';
import { PatientStateI, SearchPatientI, MedicalRecordI } from './state';
import { UserI } from '../users/state';

const actions: ActionTree<PatientStateI, RootStateI> = {
  async findbyidentification(
    context: ActionContext<PatientStateI, RootStateI>,
    payload: SearchPatientI,
  ) {
    const url = `/api/patients/findbyidentification?identification=${payload.identification}&identificationType=${payload.identificationType}`;
    const { data } = await careClient.get(url);
    const patient = snakeToCamel(data);
    context.commit('setPatient', patient);
    return patient;
  },
  async register(
    context: ActionContext<PatientStateI, RootStateI>,
    payload: UserI,
  ) {
    const { data } = await careClient.post('/api/patients/register', snakeToCamel(payload));
    const patient = snakeToCamel(data);
    context.commit('setPatient', patient);
    return patient;
  },
  async find(
    context: ActionContext<PatientStateI, RootStateI>,
    payload: FindI,
  ) {
    const params = new URLSearchParams();
    if (payload) {
      Object.entries(payload).forEach(([key, value]) => {
        if (value) {
          params.append(key, value);
        }
        if (key === 'query') {
          params.append('first_name', value);
          params.append('last_name', value);
          params.append('identification', value);
          params.append('email', value);
          // remove the query key
          params.delete('query');
        }
      });
    }

    const url = `/api/patients/find?${params.toString()}`;
    const { data } = await careClient.get(url);
    const result = snakeToCamel(data);
    context.commit('setPatientsFinded', result);
  },
  async get(
    context: ActionContext<PatientStateI, RootStateI>,
    id: number,
  ) {
    const { data } = await careClient.get(`/api/patients/get/${id}`);
    const patientUser = snakeToCamel(data);
    context.commit('setPatientUser', patientUser);
    return patientUser;
  },
  async update(
    context: ActionContext<PatientStateI, RootStateI>,
    payload: UserI,
  ) {
    const { data } = await careClient.patch(
      '/api/patients/update',
      camelToSnake(payload),
    );
    const patient = snakeToCamel(data);
    context.commit('setPatient', patient);
    return patient;
  },
  async addMedicalRecord(
    context: ActionContext<PatientStateI, RootStateI>,
    payload: MedicalRecordI,
  ) {
    const { data } = await careClient.post(
      `/api/medical-consultations/add/${payload.userId}`,
      camelToSnake(payload),
    );
    const medicalRecord = snakeToCamel(data);
    return medicalRecord;
  },
  async getMedicalConsultations(
    context: ActionContext<PatientStateI, RootStateI>,
    userId: number,
  ) {
    const { data } = await careClient.get(`/api/medical-consultations/getbypatientid/${userId}`);
    const mc = snakeToCamel(data);
    context.commit('setMedicalConsultations', mc);
    return mc;
  },
};

export default actions;
